"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _constants = require("./constants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RadioInput = (0, _styledComponents.default)(_UIRadioInput.default).withConfig({
  displayName: "RadioInput",
  componentId: "sc-1frgy0q-0"
})(_templateObject(), _constants.INPUT_STYLES);
var _default = RadioInput;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/inputs/RadioInput.js
// module id = 205
// module chunks = 209 210 211 212